import {
  //Sınıf Atlatma
  postClassLevelUp,
  postClassLevelUpExistClass,
  checkClassLevelUp,
  //Diğer
  getClassById,
  getLevelList,
  getNationalityList,
  getGenderList,
  //Class İşlemleri
  getClassList,
  getInactiveClassList,
  postNewClass,
  updateClass,
  deleteClass,
  setClassInactive,
  // getClassAssignmentList,
  postClassAssignment,
  getInactiveClassesList,
  //Lecturers
  getLecturerListByClassId,
  postLecturerToClass,
  updateLecturerToClass,
  deleteLectuerToClass,
  getLecturerInfo,

  //Toplu öğrenciye sınıf açıp atama
  postClassAssignmentStudents,
  postClassAssignmentStudentsMore,

  //kullanıcıya göre sınıf adı getirme işlemi
  getClassListToPlaylistForTeacher,
  getClassListToVideoForTeacher,
  getQueryClassList,
  saveClassAssignments,

} from "@/services/class.service";
import { setPaginationDetails } from "../../utils/utils";

import { formatDateEditZone } from "@/utils/utils";

import { setSnackbarSuccess } from "../../utils/utils";

// initial state
const state = () => ({
  classModel: {
    projectId: null,
    centerId: null,
    centerPeriodId: null,
  },

  classList: [],
  levelList: [],

  nationalityList: [],
  genderList: [],

  classAssignmentList: [],

  classAssignmentResponse: null,

  globalLecturerList: [],
  studentList: [],
});

// mutations
const mutations = {
  setStudentList(state, data) {
    state.studentList = data;
  },
  setClassModel(state, data) {
    state.classModel = data;
  },
  setClassList(state, data) {
    state.classList = data;
  },
  setLevelList(state, data) {
    state.levelList = data;
  },

  setNationalityList(state, data) {
    state.nationalityList = data;
  },
  setGenderList(state, data) {
    state.genderList = data;
  },

  setClassAssignmentList(state, data) {
    state.classAssignmentList = data;
  },

  setClassAssignmentResponse(state, data) {
    state.classAssignmentResponse = data;
  },

  setGlobalLecturerList(state, data) {
    state.globalLecturerList = data;
  },
};

// actions
const actions = {
  //Sınıf Atlatma
  async classInactive(vuexContext, classId) {
    return await setClassInactive(classId).then((response) => {
      let data = response.data.data;
      return data;
    });
  },

  //Sınıf Atlatma
  async classLevelUp(vuexContext, classId) {
    return await postClassLevelUp(classId).then((response) => {
      let data = response.data.data;
      return data;
    });
  },

  async postClassLevelUpExistClass(vuexContext, data) {
    return await postClassLevelUpExistClass(data).then((response) => {
      let data = response.data.data;
      return data;
    });
  },

  async getCheckClassLevelUpStudents(vuexContext, classId) {
    return await checkClassLevelUp(classId).then((response) => {
      setSnackbarSuccess(response.data.message);
      let data = response?.data?.data;
      data?.map((item, index) => {
        item.index = index + 1;
        item.userStudentClassDtos.forEach((scoringType) => {
          item[scoringType.scoringTypeId] = scoringType.score;
          if (scoringType.failedFromClass === true) {
            item.failedFromClass = true;
            item.failedScoreType = scoringType.scoringTypeName;
          }
        });
      });
      return data;
    });
  },
  //!Sınıf Atlatma

  async loadClassById(vuexContext, classId) {
    return await getClassById(classId).then((response) => {
      let data = response.data.data;
      data.map((item,index)=>{
        item.index = index+1;
        item.id = item.userStudent.id;
        item.firstName = item.userStudent.firstName,
        item.lastName =item.userStudent.lastName,
        item.email = item.userStudent.email,
        item.phone = item.userStudent.tel,
        // country = item.userStudent.
        item.level = item.userStudent.levels.description
        item.paidType = item.userStudent.paidId ==1 ?"ücretli" : "ücretsiz",
        item.educationType = item.userStudent.educationType,
        //situation = 
        item.lastLevel = item.class.name
       });
      vuexContext.commit("setStudentList", data);
      return data;
    });
  },

  async loadInactiveClassList() {
    return await getInactiveClassList().then((response) => {
      let data = response.data.data;
      data.map((item, index) => {
        item.index = index;
        item.label = item.name + (item.classStatusMulti?.classEndType?.name ? " / " + item.classStatusMulti?.classEndType?.name : "");
      });
      return data;
    });
  },

  async loadClassList(vuexContext, co) {
    if(co.filter != null || undefined)  
    {
      co.pageIndex = 0;
      co.pageSize = 1000;
    }
    return await getClassList(co).then((response) => {    
      //console.log("ressss",response);
      let data = response.data.data;
      let items = data.items;
      let totalCount = data.totalCount;
      let totalPages = data.totalPages;
      items.map((item, index) => {
        item.index = index + 1;
        item.showStudentListByClassId = item.id;
        //console.log("periıd" , item.timePeriod);
        //item.educationTypeId = item.educationType.id;
        // item.paidId = item.paid.id;
        // item.levelsId = item.levels.id;
        // item.classDayAndTime = "";
        // item.dayAndTime = "";
        item.studentCountQuota = item.studentCount + " / " + item.quota;
        if (item.classDayAndTimeDto.length < 1) {
          item.classDayAndTime = "Veri girişi yapılmadı.";
          item.dayAndTime = "Veri girişi yapılmadı.";
        }
        else{
          item.classDayAndTime = "";
          item.dayAndTime = "";
        }
        //item.kurBilgisi =  item?.classStatusMultiDto?.classStatusDto ? item.classStatusMultiDto.classStatusDto?.startTime+" - "+item.classStatusMultiDto.classStatusDto?.endTime+" / "+item.classStatusMultiDto.levelsDto.description : "LMS Ekibiyle İletişime Geçin";

         // item.kurBilgisi = item.classStatusMultiDto.classStatusDto?.startTime+" - "+item.classStatusMultiDto.classStatusDto?.endTime+" / "+item.classStatusMultiDto.levelsDto.description;
        item.classDayAndTimeDto.forEach((dayTime, index) => {
          //TSİ
          item.classDayAndTime += `${dayTime.day.name} ${formatDateEditZone(dayTime.startDate, item.timePeriod, "+03:00")} - ${formatDateEditZone(dayTime.endDate, item.timePeriod, "+03:00")}
          `;
          if (index < item.classDayAndTimeDto.length - 1) {
            item.classDayAndTime += " / ";
          }

          //Normal
          item.dayAndTime += `${dayTime.day.name} ${formatDateEditZone(dayTime.startDate, "+03:00", "+03:00")} -  ${formatDateEditZone(dayTime.endDate, "+03:00", "+03:00")}
          `;
          if (index < item.classDayAndTimeDto.length - 1) {
            item.dayAndTime += " / ";
          }
       });
      });
      // if (co.withoutPagination === undefined) {
      //   vuexContext.rootState.pagination.totalRecords = totalCount;
      //   vuexContext.rootState.pagination.totalPages = totalPages;
      // }
      setPaginationDetails(co, totalCount, totalPages);
      vuexContext.commit("setClassList", items);

      return items;
    });
  },
  async loadInactiveClassesList(vuexContext, co) {
    return await getInactiveClassesList(co).then((response) => {    
      //console.log("ressss",response);
      let data = response.data.data;
      let items = data.items;
      let totalCount = data.totalCount;
      let totalPages = data.totalPages;
      items.map((item, index) => {
        item.index = index + 1;
        item.showStudentListByClassId = item.id;
        //console.log("periıd" , item.timePeriod);
        //item.educationTypeId = item.educationType.id;
        // item.paidId = item.paid.id;
        // item.levelsId = item.levels.id;
        // item.classDayAndTime = "";
        // item.dayAndTime = "";
        item.studentCountQuota = item.studentCount + " / " + item.quota;
        if (item.classDayAndTimeDto.length < 1) {
          item.classDayAndTime = "Veri girişi yapılmadı.";
          item.dayAndTime = "Veri girişi yapılmadı.";
        }
        else{
          item.classDayAndTime = "";
          item.dayAndTime = "";
        }
        //item.kurBilgisi =  item?.classStatusMultiDto?.classStatusDto ? item.classStatusMultiDto.classStatusDto?.startTime+" - "+item.classStatusMultiDto.classStatusDto?.endTime+" / "+item.classStatusMultiDto.levelsDto.description : "LMS Ekibiyle İletişime Geçin";

         // item.kurBilgisi = item.classStatusMultiDto.classStatusDto?.startTime+" - "+item.classStatusMultiDto.classStatusDto?.endTime+" / "+item.classStatusMultiDto.levelsDto.description;
        item.classDayAndTimeDto.forEach((dayTime, index) => {
          //TSİ
          item.classDayAndTime += `${dayTime.day.name} ${formatDateEditZone(dayTime.startDate, item.timePeriod, "+03:00")} - ${formatDateEditZone(dayTime.endDate, item.timePeriod, "+03:00")}
          `;
          if (index < item.classDayAndTimeDto.length - 1) {
            item.classDayAndTime += " / ";
          }

          //Normal
          item.dayAndTime += `${dayTime.day.name} ${formatDateEditZone(dayTime.startDate, "+03:00", "+03:00")} -  ${formatDateEditZone(dayTime.endDate, "+03:00", "+03:00")}
          `;
          if (index < item.classDayAndTimeDto.length - 1) {
            item.dayAndTime += " / ";
          }
       });
      });
      // if (co.withoutPagination === undefined) {
      //   vuexContext.rootState.pagination.totalRecords = totalCount;
      //   vuexContext.rootState.pagination.totalPages = totalPages;
      // }
      setPaginationDetails(co, totalCount, totalPages);
      vuexContext.commit("setClassList", items);

      return items;
    });
  },

  async postClassAssignmentStudents(vuexContext, data) {
    return await postClassAssignmentStudents(data);
  },

  async postClassAssignmentStudentsMore(vuexContext, data) {
    return await postClassAssignmentStudentsMore(data);
  },

  // async loadClassAssignmentList(vuexContext, centerPeriodId) {
  //   await getClassAssignmentList(centerPeriodId).then((response) => {
  //     let data = response.data.data.items;
  //     data.map((item, index) => {
  //       item.value = item.id;
  //       item.index = index + 1;
  //       item.label = item.className;
  //     });
  //     vuexContext.commit("setClassAssignmentList", data);
  //   });
  // },

  async postClassAssignment(vuexContext, data) {
    vuexContext.commit("setClassAssignmentResponse", data);
    return await postClassAssignment(data);
  },

  async saveClassAssignments(vuexContext, data) {
    vuexContext.commit("setClassAssignmentResponse", data);
    return await saveClassAssignments(data);
  },
  
  async postNewClass(vuexContext, data) {
    data.name = data.className;
    data.levelsId = data.levelId;
    data.weeklyLessonHours = parseFloat(data.weekHour);
    return await postNewClass(data).then((response) => {
      return response;
    });
  },

  async updateClass(vuexContext) {
    vuexContext.state.classModel.name = vuexContext.state.classModel.className;
    vuexContext.state.classModel.levelsId = vuexContext.state.classModel.levelId;
    vuexContext.state.classModel.weeklyLessonHours = parseFloat(vuexContext.state.classModel.weekHour);
    return await updateClass(vuexContext.state.classModel);
  },

  async deleteClass(vuexContext) {
    return await deleteClass(vuexContext.state.classModel.id);
  },

  //Level Listesi
  async loadLevelList(vuexContext) {
    return await getLevelList().then((response) => {
      let data = response.data.data;
      data.map((level, index) => {
        level.value = level.id;
        level.index = index + 1;
        level.label = level.description;
      });

      data.sort((a, b) => {
        return a - b;
      });

      vuexContext.commit("setLevelList", data);
      return data;
    });
  },

  //Uyruk Listesi
  async loadNationalityList(vuexContext) {
    return await getNationalityList().then((response) => {
      let data = response.data.data;
      data.map((level, index) => {
        level.index = index + 1;
      });
      vuexContext.commit("setNationalityList", data);
      return data;
    });
  },

  //Cinsiyet Listesi
  async loadGenderList(vuexContext) {
    return await getGenderList().then((response) => {
      let data = response.data.data;
      data.map((item, index) => {
        item.index = index + 1;
      });
      vuexContext.commit("setGenderList", data);
      return data;
    });
  },

  //Lecturers
  async loadLecterListByClassId(vuexContext, co) {
    return await getLecturerListByClassId(co).then((response) => {
      let data = response.data.data;
      let items = data.items;
      let totalCount = data.totalCount;
      let totalPages = data.totalPages;

      items.map((item) => {
        item.person = { value: item.personDto.personId, label: `${item.personDto.name} ${item.personDto.lastName}` };
        item.value = item.personDto.personId;
        item.label = `${item.personDto.name} ${item.personDto.lastName}`;
      });

      setPaginationDetails(co, totalCount, totalPages);
      return items;
    });
  },

  async loadLecturerInfo(vuexContext, co) {
    return await getLecturerInfo(co).then((response) => {
      let data = response.data.data;
      return data;
    });
  },

  async postLecturerToClass(vuexContext, data) {
    return await postLecturerToClass(data).then((response) => {
      let data = response;
      return data;
    });
  },

  async updateLecturerToClass(vuexContext, data) {
    return await updateLecturerToClass(data).then((response) => {
      let data = response;
      return data;
    });
  },

  async deleteLectuerToClass(vuexContext, data) {
    return await deleteLectuerToClass(data).then((response) => {
      let data = response;
      return data;
    });
  },

  async loadClassListToPlaylistForTeacher(vuexContext, playlistid) {    

    return await getClassListToPlaylistForTeacher(playlistid).then((response) => {
      let data = response.data.data;
      let items = data.items;

      items.map((item, index) => {
        item.index = index + 1;
      });
      return items;
    });
  },  

  async loadClassListToVideoForTeacher(vuexContext, videoid) {    

    return await getClassListToVideoForTeacher(videoid).then((response) => {
      let data = response.data.data;
      let items = data.items;

      items.map((item, index) => {
        item.index = index + 1;
      });
      return items;
    });
  },  

  addClassModel(vuexContext, data) {
    vuexContext.commit("setClassModel", data);
  },

  addClassAssignmentList(vuexContext, data) {
    vuexContext.commit("setClassAssignmentList", data);
  },

  addClassList(vuexContext, data) {
    vuexContext.commit("setClassList", data);
  },

  addGlobalLecturerList(vuexContext, data) {
    vuexContext.commit("setGlobalLecturerList", data);
  },


  //Sınıf Listesi Çekme Yeni
  async loadQueryClassList(vuexContext, co) {
    if(co.filter != null || undefined)  
    {
      co.pageIndex = 0;
      co.pageSize = 1000;
    }
    return await getQueryClassList(co).then((response) => {

      let data = response.data;
      return data;
    });
  },
};

// getters
const getters = {};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
